import React, { Component } from 'react'
import { connect } from 'react-redux'
import dayjs from 'dayjs'
import 'dayjs/locale/nl'
import { showOrderModal } from '../../../redux/actions/miscActions'
import { Table, Badge } from 'antd';
dayjs.locale('nl')

export class OrdersTable extends Component {


  handleEdit=(text, record)=>{
    this.props.showOrderModal(record)
  }

  render() {

    const columns = [
      { title: 'Order#', dataIndex: 'orderNumber', key: 'orderNumber' },
      { title: 'Customer', key: 'name', render:(text, record) =>  text.cust.name},
      { title: 'Email', key: 'email', render:(text, record) =>  text.cust.email},      
      { title: 'Cost', dataIndex: 'orderCost', key: 'orderCost', render:(text, record) => `${new Intl.NumberFormat('IN', { style: 'currency', currency: 'SRD'}).format(`${(record.orderCost)}`)}`  },      
      { title: 'Date', key: 'date', render:(text, record) => dayjs(text.date.toDate()).format('DD MMM YY') },      
      { title: 'Status', dataIndex: 'status', key: 'status', render:(text, record)=> record.status === 'pending' ? <span><Badge status="processing" />pending</span> : record.status === 'cancelled' ? <span><Badge status="error" />geannuleerd</span> : record.status === 'processing' ?  <span><Badge status="warning" />in behandeling</span> : <span><Badge status="success" />afgewerkt</span>},      
      { title: 'Action', key: 'operation', render: (text, record) => <i className="fas fa-pencil-alt" onClick={()=>this.handleEdit(text, record)}></i>  },
    ];
    return (
      <div className="orders-table-container">
        <Table
          className="orders-table"
          columns={columns}
          pagination={{ pageSize: 7 }}
          locale={{...this.props}}
          {...this.props}
        />
      </div>
    )
  }
}

export default connect(null, {showOrderModal})(OrdersTable)
